import { Component, OnInit } from "@angular/core";
import { Location } from "@angular/common";
import { FormBuilder, Validators } from "@angular/forms";
import { environment } from "../../environments/environment";
import { DepositFormComponent } from "../modals/deposit-form/deposit-form.component";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { TransactionService } from "../services/transaction.service";
import { WithdrawFormComponent } from "../modals/withdraw-form/withdraw-form.component";
import { DepositAutopayComponent } from "../modals/deposit-autopay/deposit-autopay.component";
import { QrcodeShowComponent } from "../modals/qrcode-show/qrcode-show.component";
import { ToastrService } from "ngx-toastr";
// import * as QRCode from "qrcode";
const QRCode: any = require("qrcode");

@Component({
  selector: "app-deposit",
  templateUrl: "./deposit.component.html",
  styleUrls: ["./deposit.component.css"],
})
export class DepositsComponent implements OnInit {
  name = "100x Wins";
  qrImageSrc: string = "";

  deposit_requests: any = [];
  withdraw_requests: any = [];
  selectedTabIndex = 0;
  depositAmount: number = 0;
  paymentUrl: any = "";
  isDepositProceed: boolean = false;

  // manual deposit
  depositForm: any;
  selectedFile: any = null;
  errorMsg: any;
  submitted = false;
  gpay: any = "";
  paytm: any = "";
  phonepe: any = "";
  bank: any = "";
  qrcode: any = "";
  currentPayment: any = "";
  methodval: any = "other";

  is_gpayActive: boolean = false;
  is_paytmActive: boolean = false;
  is_phonepeActive: boolean = false;
  is_qrActive: boolean = false;
  is_otherActive: boolean = false;

  user_id = localStorage.getItem("user_id");
  username = localStorage.getItem("username");
  showUpiTextbox: boolean = true;
  selected_radio: any = "other";
  selectedFileName: string = "";

  constructor(
    public dialog: MatDialog,
    private transactionService: TransactionService,
    private _location: Location,
    private fb: FormBuilder,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.generateUPIQRCode();
    this.getDepositRequests();
    this.getWithdrawRequests();
    this.transactionService.refreshDepositRequests.subscribe(() => {
      this.getDepositRequests();
    });
    this.transactionService.refreshWithdrawRequests.subscribe(() => {
      this.getWithdrawRequests();
    });

    this.depositForm = this.fb.group({
      user_id: [this.user_id, Validators.required],
      method: ["", Validators.required],
      transaction_id: ["", Validators.required],
      amount: ["", Validators.required],
      depo_proof: ["", Validators.required],
      username: [this.username, Validators.required],
    });

    this.transactionService.getUPI().subscribe((res: any) => {
      const imageBaseUrl = environment.image_url;
      if (res != null) {
        if (res.gpay) {
          this.is_gpayActive = true;
          this.gpay = res.gpay;
        }

        if (res.paytm) {
          this.is_paytmActive = true;
          this.paytm = res.paytm;
        }

        if (res.phonepe) {
          this.is_phonepeActive = true;
          this.phonepe = res.phonepe;
        }
        if (res.qrcode != "/no_file.png") {
          this.is_qrActive = true;
          this.qrcode = imageBaseUrl + res.qrcode;
        }

        if (res.account_id) {
          this.is_otherActive = true;
          this.bank = `${res.account_id}, <br> ${res.ifsc_code}, <br> ${res.bank_name}, <br> ${res.branch},  `;
        }

        // this.currentPayment = res.gpay ? res.gpay : "not found";
        switch (true) {
          case this.is_otherActive:
            this.currentPayment = this.bank;
            this.selected_radio = "other";
            break;
          case this.is_qrActive:
            this.currentPayment = `<img src="${this.qrcode}" class="w150" >`;
            this.selected_radio = "qrcode";

            break;
          case this.is_phonepeActive:
            this.currentPayment = this.phonepe;
            this.selected_radio = "phonepe";

            break;
          case this.is_paytmActive:
            this.currentPayment = this.paytm;
            this.selected_radio = "paytm";

            break;
          case this.is_gpayActive:
            this.currentPayment = this.gpay;
            this.selected_radio = "gpay";

            break;
          default:
            this.currentPayment = "No payment method found";
        }
        this.methodval = this.selected_radio;
      }
    });
  }

  generateUPIQRCode() {
    const upiLink = `upi://pay?pa=${
      this.currentPayment
    }&pn=${encodeURIComponent(this.name)}&cu=INR`;
    QRCode.toDataURL(upiLink, { width: 250 }, (err: any, url: any) => {
      if (err) {
        console.error("QR Code generation failed", err);
      } else {
        this.qrImageSrc = url;
      }
    });
  }

  toggleUpiTextbox() {
    this.showUpiTextbox = true;
  }
  get depositFormControl() {
    return this.depositForm.controls;
  }
  onFileSelected(event: any) {
    this.selectedFile = event.target.files[0];
    if (this.selectedFile) {
      this.selectedFileName = this.selectedFile.name;
      this.depositForm.get("depo_proof")?.setValue(this.selectedFile);
    }
  }

  chooseMethod(event: any) {
    this.selected_radio = event.target.value;
    if (event.target.value == "paytm") {
      this.currentPayment = this.paytm ? this.paytm : "not found";
      this.generateUPIQRCode();
    } else if (event.target.value == "phonepe") {
      this.currentPayment = this.phonepe ? this.phonepe : "not found";
      this.generateUPIQRCode();
    } else if (event.target.value == "gpay") {
      this.currentPayment = this.gpay ? this.gpay : "not found";
      this.generateUPIQRCode();
    } else if (event.target.value == "other") {
      this.currentPayment = this.bank ? this.bank : "not found";
    } else if (event.target.value == "qrcode") {
      this.currentPayment = this.qrcode
        ? `<img src="${this.qrcode}" class="w150" >`
        : "not found";
    } else {
      this.currentPayment = this.gpay ? this.gpay : "not found";
    }
    // const dialogRef = this.dialog.open(QrcodeShowComponent, {
    //   autoFocus: false,
    //   maxHeight: "100vh",
    //   disableClose: true,
    //   data: {
    //     paymentType: event.target.value,
    //     paymentData: this.currentPayment,
    //     qrCode: this.qrcode
    //   }
    // });
  }

  copyMessage(val: any) {
    const selBox: any = document.createElement("textarea");
    selBox.style.position = "fixed";
    selBox.style.left = "0";
    selBox.style.top = "0";
    selBox.style.opacity = "0";

    // extract html
    const span = document.createElement("span");
    span.innerHTML = val;

    selBox.value = span.textContent || span.innerText;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand("copy");
    document.body.removeChild(selBox);
  }

  addDepositRequest() {
    //this.openDialog('deposit');
    const dialogRef = this.dialog.open(DepositAutopayComponent, {
      autoFocus: false,
      maxHeight: "100vh",
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      this.getDepositRequests();
    });
  }

  addManualDepositRequest() {
    const dialogRef = this.dialog.open(DepositFormComponent, {
      autoFocus: false,
      maxHeight: "100vh",
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      this.getDepositRequests();
    });
  }

  submitManualDepositRequest() {
    this.submitted = true;
    if (this.depositForm.invalid) {
      return;
    } else {
      const formData = new FormData();

      // @ts-ignore
      formData.append("user_id", this.user_id.toString());
      formData.append("method", this.depositForm.value.method);
      formData.append("amount", this.depositForm.value.amount);
      formData.append("transaction_id", this.depositForm.value.transaction_id);
      // @ts-ignore
      formData.append("username", this.username);
      formData.append("file", this.selectedFile, this.selectedFile.name);
      // let request_details = {
      //   user_id: this.user_id,
      //   amount: this.depositForm.value.amount,
      //   transaction_id: this.depositForm.value.transaction_id,
      //   username: this.username
      // };
      console.log("form data-->", formData);
      this.transactionService
        .addDepositRequest(formData)
        .subscribe((res: any) => {
          if (res.error) {
            this.errorMsg = res.error;
          } else {
            this.toastr.success("Deposit Request Sent");
            const selectedMethod = this.depositForm.value.method;
            this.depositForm.reset();
            this.depositForm.patchValue({ method: selectedMethod });
            this.submitted = false;
            this.selectedFile = null;
            this.selectedFileName = "";
          }
        });
    }
  }

  addWithdrawRequest() {
    this.openDialog("withdraw");
  }

  getDepositRequests() {
    this.transactionService.getDepositRequests().subscribe((res: any) => {
      this.deposit_requests = res;
      // console.log(this.deposit_requests);
    });
  }

  getWithdrawRequests() {
    this.transactionService.getWithdrawRequests().subscribe((res: any) => {
      this.withdraw_requests = res;
      // console.log(this.withdraw_requests);
    });
  }

  config: MatDialogConfig = {
    disableClose: false,
    hasBackdrop: true,
    backdropClass: "test",
    width: "90%",
    height: "50%",
    panelClass: "makeItMiddle", //Class Name that can be defined in styles.css as follows:
  };

  openDialog(type: any) {
    if (type == "deposit") {
      const dialogRef = this.dialog.open(DepositFormComponent, {
        autoFocus: false,
        maxHeight: "100vh",
      });
      dialogRef.afterClosed().subscribe((result: any) => {
        console.log(`Dialog result: ${result}`);
      });
    }
    if (type == "withdraw") {
      const dialogRef = this.dialog.open(WithdrawFormComponent, {
        autoFocus: false,
        maxHeight: "100vh",
      });
      dialogRef.afterClosed().subscribe((result: any) => {
        console.log(`Dialog result: ${result}`);
      });
    }
  }

  selectTab(index: number): void {
    this.selectedTabIndex = index;
  }

  addAmount(amount: number) {
    this.depositAmount += amount;
  }

  clearAmount() {
    this.depositAmount = 0;
  }

  proceedDeposit() {
    if (this.depositAmount <= 0) {
      alert("Please enter a valid deposit amount!");
      return;
    }
    this.isDepositProceed = true;
    this.transactionService
      .testpayment({ amount: this.depositAmount })
      .subscribe(
        (res: any) => {
          if (res.status) {
            this.paymentUrl = res.payInfo;
            this.redirectVPA();
          } else {
            alert(res.message);
          }
          this.isDepositProceed = false;
        },
        (error) => {
          console.error("Payment API error:", error);
          alert("Something went wrong, please try again.");
          this.isDepositProceed = false;
        }
      );
  }

  redirectVPA() {
    location.href = this.paymentUrl;
  }

  backClicked() {
    this._location.back();
  }
}
